module.exports = __webpack_public_path__ + "img/logo_hzkq.b464fb0a.png";